module.exports = __webpack_public_path__ + "static/media/radioTv.1ec78df8.svg";